export default __webpack_public_path__ + "static/media/eatingtimes_1@3x.58845923.jpg";